import React, { useContext, useEffect, useRef, useState } from 'react';
import { store } from 'components/Store';
import time from 'utils/time';
import normalize from 'components/Dashboard/utilities/normalizeString';
import RenderingTags from './RenderingTags';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import useTopicOrClientWord from 'components/Dashboard/hooks/useTopicOrClientWord';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';

const TagsLists = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { search, keywordsLists } = state;

  const {
    index,
    title,
    embargoed,
    feedItemFlags,
    embargoedUntil,
    calendarTags,
    live,
    remarkInformation,
    watchItem,
    ended,
    tagsFixedPosition,
    scrollBarRef,
    onlyEmbargoedTag,
  } = props;
  const topicIdQuery = getUrlParam('topic-id');
  const list =
    search?.list === 'noListsCreated'
      ? search?.list
      : keywordsLists.find((item) => item.id === (topicIdQuery === 'all' ? null : parseInt(topicIdQuery)));

  const tagsContainer = useRef(null);
  const embargoTagRef = useRef(null);
  const [embargoTruncated, setEmbargoTruncated] = useState(false);

  const { newAgencyPlan } = useTopicOrClientWord();
  const isMobile = useIsMobile();

  const embargoText = isMobile
    ? 'Under embargo'
    : `Embargoed ${!!embargoedUntil ? `until ${time(embargoedUntil).formatEmbargoedDate()}` : ''}`;

  useEffect(() => {
    if (!(onlyEmbargoedTag && embargoed)) return;
    const el = embargoTagRef.current;
    if (!el) return;
    const checkOverflow = () => setEmbargoTruncated(el.scrollWidth > el.offsetWidth);
    checkOverflow();

    let resizeObserver;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(checkOverflow);
      resizeObserver.observe(el);
    } else {
      window.addEventListener('resize', checkOverflow);
    }

    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {
        window.removeEventListener('resize', checkOverflow);
      }
    };
  }, [onlyEmbargoedTag, embargoed, embargoText]);

  const feedItemsConditional = list !== null && feedItemFlags?.length > 0;
  const handPicked = feedItemsConditional && feedItemFlags[index]?.isHandPicked;
  const listConditions = keywordsLists?.length > 1 || newAgencyPlan;
  const matchingKeywordLists =
    (feedItemsConditional || calendarTags) && listConditions && feedItemFlags[index]?.matchingKeywordLists?.length > 0;
  const createMatchingKeywords = () => {
    let terms = [];
    if (matchingKeywordLists) {
      if (newAgencyPlan && calendarTags) {
        let lists = feedItemFlags[index].matchingKeywordLists;
        let finalLists = [];
        for (let i = 0; i < lists?.length; i++) {
          let list = lists[i];
          let teamNamePosition = finalLists?.findIndex((item) => item.teamName === list?.teamName);
          if (teamNamePosition >= 0) {
            let finalItem = finalLists[teamNamePosition];
            finalLists[teamNamePosition] = { ...finalItem, topics: [...finalItem?.topics, list?.name] };
          } else {
            finalLists.push({ ...list, topics: [list?.name] });
          }
        }
        terms = finalLists;
      } else {
        terms = feedItemFlags[index].matchingKeywordLists;
      }
    }
    if (embargoed) {
      let embargoedItem = {
        embargoed: true,
        name: isMobile
          ? 'Under embargo'
          : `Embargoed ${!!embargoedUntil ? `until ${time(embargoedUntil).formatEmbargoedDate()}` : ''}`,
      };
      if (embargoedUntil) {
        embargoedItem.embargoedUntil = embargoedUntil;
      }
      terms = [embargoedItem, ...terms];
    }

    if (live) {
      let liveItem = {
        live: true,
        name: ended ? 'Ended' : 'Live',
        ended,
      };
      if (remarkInformation) {
        liveItem = {
          ...liveItem,
          ...remarkInformation,
        };
        terms = isMobile ? [...terms] : [liveItem, ...terms];
      } else {
        terms = [liveItem, ...terms];
      }
    }

    return terms;
  };

  const matchingKeywords = createMatchingKeywords();
  const filteredMatchingKeywords = matchingKeywords.filter((item) => !onlyEmbargoedTag || item.embargoed);

  return (
    <>
      <div
        ref={tagsContainer}
        className={`explanations specific-bottom-padding-6 mb-0 row mx-0 align-items-start 
      ${title ? `explanations-${normalize(title)}` : ''} ${embargoed || handPicked ? 'explanations-handpicked' : ''}`}
      >
        {onlyEmbargoedTag && embargoed ? (
          <>
            <div className='flex-centered rendering-items-container position-relative pr-0'>
              <div
                className='d-flex align-items-start flex-wrap overflow-hidden position-relative'
                style={{ maxHeight: '38px' }}
              >
                <p className='position-relative explanation-container under-embargo-list-item'>
                  <span
                    className='explanation-tag tag-keyword-list'
                    ref={embargoTagRef}
                    data-tooltip-id={embargoTruncated ? 'tags-tooltip' : undefined}
                    data-tooltip-content={embargoTruncated ? embargoText : undefined}
                  >
                    <span className='icon-clock'></span>
                    {embargoText}
                  </span>
                </p>
              </div>
            </div>
          </>
        ) : (
          <>
            {' '}
            {(matchingKeywordLists || embargoed || live || watchItem) && filteredMatchingKeywords?.length > 0 && (
              <>
                <RenderingTags
                  terms={filteredMatchingKeywords}
                  matchingKeywordLists
                  calendarTags={calendarTags}
                  fixedPosition={tagsFixedPosition}
                  scrollBarRef={scrollBarRef}
                />
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default TagsLists;
